export const aiTextTools: string[] = [
  'ChatGPT (OpenAI)',
  'Claude (Anthropic)',
  'Gemini (Google)',
  'Microsoft Copilot',
  'Grok (xAI)',
  'Other'
];
